<a class="btn font-weight-bold px-6  primary-ebtn py-3" data-toggle="dropdown" aria-haspopup="true"
    aria-expanded="false" ngbDropdownToggle>
    <!-- Export Data Sheet -->
    {{ 'INFORMATE_HEADER.BUTTONS_TEXT.EXPORT_REPORTS' | transloco }}
</a>
<div class="dropdown-menu dropdown-menu-wrap p-0 m-0 dropdown-menu-md dropdown-menu-left" ngbDropdown>
    <ul class="navi navi-hover py-5">
        <li class="navi-item">
            <a class="navi-link cursor-pointer" (click)="openCreateDataSheetModal()">
                <span class="navi-text">{{ 'INFORMATE_HEADER.BUTTONS_TEXT.EXPORT_REPORTS_OPTIONS.CREATEDATASHEET' |
                    transloco }}</span></a>
        </li>
        <li class="navi-item">
            <a class="navi-link cursor-pointer" (click)="openJointCompletionReport()"><span class="navi-text"> {{
                    'INFORMATE_HEADER.BUTTONS_TEXT.EXPORT_REPORTS_OPTIONS.CREATEJCC' | transloco }}</span></a>
        </li>
    </ul>
</div>